import { FC, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import {
  LayoutContainer,
  LayoutContent,
  LayoutSidebar,
} from 'src/components/layout/sidebar';
import { PageSpinner } from 'src/components/spinner-container';
import { Heading } from 'src/components/text/heading';
import { Assignments } from 'src/pages/operators/assignments';
import { ShipperInvoicesOverview } from 'src/pages/operators/invoices';
import { ShipperInvoiceDetail } from 'src/pages/operators/invoices/detail';
import { OperatorDocuments } from 'src/pages/operators/operator-documents';
import { OperatorsSidebar } from 'src/pages/operators/operators-sidebar';

export const Operators: FC = () => {
  return (
    <LayoutContainer>
      <Heading mode="title">Operators</Heading>
      <LayoutSidebar>
        <OperatorsSidebar />
      </LayoutSidebar>
      <Suspense
        fallback={
          <LayoutContent>
            <PageSpinner />
          </LayoutContent>
        }
      >
        <Switch>
          <Route
            path={[
              '/operators/assignments',
              '/dashboard/operators/assignments',
            ]}
          >
            <LayoutContent>
              <Assignments />
            </LayoutContent>
          </Route>

          <Route path="/operators/operator-documents">
            <LayoutContent>
              <OperatorDocuments />
            </LayoutContent>
          </Route>

          <Route path="/operators/invoices/:invoiceId">
            <LayoutContent>
              <ShipperInvoiceDetail />
            </LayoutContent>
          </Route>

          <Route path="/operators/invoices">
            <LayoutContent>
              <ShipperInvoicesOverview />
            </LayoutContent>
          </Route>

          <Redirect from="/operators" exact to="/operators/assignments" />

          <Route>
            <LayoutContent>
              <ThrowNotFound />
            </LayoutContent>
          </Route>
        </Switch>
      </Suspense>
    </LayoutContainer>
  );
};
